module.exports = __webpack_public_path__ + "static/media/grid_girls.57aca750.png";